/**
 * signup-countries.ts — the countries the PUBLIC sign-up form offers (Jeff, 5 October 2026, D3).
 *
 * Copy-fork of `lambdas/shared/src/signup-countries.ts`, which carries the rule: SEVEN countries —
 * Jeff's five plus Ireland and Singapore, chosen for prosperity, not size (ADR-073 Amendment 5,
 * 5 October 2026; it replaces the 20-country list of ADR-124 A1.1). signup-api enforces the same
 * list server-side; `signup-onboarding-parity.test.ts` fails the build if the two copies disagree.
 *
 * Public sign-up only: the served zone map keeps all 249 countries for every other flow.
 */
import type { ZoneMap } from '../obw/residency';
import { countryName } from '../obw/residency';

export const SIGNUP_COUNTRIES: readonly string[] = ['US', 'GB', 'CA', 'AU', 'NZ', 'IE', 'SG'];

/** The select value for "my country isn't listed" — never a country code, never defaulted. */
export const COUNTRY_NOT_LISTED = 'not-listed';

/** D3 copy, verbatim from the brief. */
export const COUNTRY_NOT_AVAILABLE_LINE = 'Nexanomics isn’t available in your country yet.';

/** The shortlist as select options — only countries the served map actually places, by name. */
export function signupCountryOptions(map: ZoneMap): { code: string; name: string }[] {
  return SIGNUP_COUNTRIES.filter((code) => Boolean(map.countries[code]))
    .map((code) => ({ code, name: countryName(code) }))
    .sort((a, b) => a.name.localeCompare(b.name));
}
